
export const LoadingCurrencyMessage = {
    CLP: 'Convirtiendo a Pesos...',
    UF: 'Convirtiendo a Unidad de Fomento...',
    USD: 'Convirtiendo a Dólares...',
    EUR: 'Convirtiendo a Euros...',
    GBP: 'Convirtiendo a Libras Esterlinas...',
    MXN: 'Convirtiendo a Pesos Mexicanos...',
    UTM: 'Convirtiendo a Unidad Tributaria Mensual...',
}

export const LoadingViewMessage = {
    day: 'Cargando Vista Diaria...',
    week: 'Cargando Vista Semanal...',
    month: 'Cargando Vista Mensual...',
}

export const LoadingProjectionMessage = {
    true: 'Agregando proyecciones...',
    false: 'Quitando proyecciones...',
}